import React from "react";
import { PeopleManager } from "@/components/account/PeopleManager";

export const PeopleTab: React.FC = () => <PeopleManager headingLevel={2} />;
